{
  "ariaLabel": "Favorittmarkering"
}
